import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse } from '../common/types';
import type { SearchSubmissionPayload, MoveManuscriptReviewToAuthorPayload } from '../submissions/types';
import type {
    ManuscriptReview,
    GetReviewerAssessmentResponse,
    ReviewAssessmentPayload,
    ReviewConflictPayload,
    ManuscriptReviewByDeskItem,
    GetManuscriptReviewByDeskPayload,
    MoveManuscriptReviewPayload,
    RequestRevisedCopyFromAuthorPayload,
    AssignReviewerEvaluationPanelPayload,
    AssignReviewerEvaluationPanelResult,
} from './types';

export const reviewAssessmentService = {
    getReviewerAssessment: async (
        reviewAssignmentId: string
    ): Promise<ApiResponse<GetReviewerAssessmentResponse>> => {
        const response = await apiClient.get(
            `/Reviews/GetReviewerAssessment?reviewAssignmentId=${reviewAssignmentId}`
        );
        return response.data;
    },

    submitReviewAssessment: async (
        payload: ReviewAssessmentPayload
    ): Promise<ApiResponse<ManuscriptReview>> => {
        const response = await apiClient.post('/Reviews/ReviewAssessment', payload);
        return response.data;
    },

    submitReviewAssessmentFormData: async (
        formData: FormData
    ): Promise<ApiResponse<ManuscriptReview>> => {
        const response = await apiClient.post('/Reviews/ReviewAssessment', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    reviewConflict: async (
        payload: ReviewConflictPayload
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/Reviews/ReviewConflict', payload);
        return response.data;
    },
};

export const manuscriptReviewByDeskService = {
    searchManuscriptReviews: async (
        payload: SearchSubmissionPayload
    ): Promise<ApiResponse<PaginatedResponse<ManuscriptReviewByDeskItem>>> => {
        const response = await apiClient.post('/Reviews/SearchForManuscriptReview', payload);
        return response.data;
    },

    getManuscriptReviewByDesk: async (
        payload: GetManuscriptReviewByDeskPayload
    ): Promise<ApiResponse<PaginatedResponse<ManuscriptReviewByDeskItem>>> => {
        const response = await apiClient.post('/Reviews/GetManuscriptReviewByDesk', {
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            sortBy: payload.sortBy || '',
            sortDescending: payload.sortDescending ?? true,
            search: payload.search || '',
            categoryId: payload.categoryId ?? 0,
        });
        return response.data;
    },

    getManuscriptAllReviewByDesk: async (
        payload: GetManuscriptReviewByDeskPayload
    ): Promise<ApiResponse<PaginatedResponse<ManuscriptReviewByDeskItem>>> => {
        const response = await apiClient.post('/Reviews/GetManuscriptAllReviewByDesk', {
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            sortBy: payload.sortBy || '',
            sortDescending: payload.sortDescending ?? true,
            search: payload.search || '',
            categoryId: payload.categoryId && payload.categoryId > 0 ? payload.categoryId : null,
        });
        return response.data;
    },

    moveManuscriptReview: async (
        payload: MoveManuscriptReviewPayload
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            '/ReviewerEvaluations/MoveManuscriptReview',
            payload
        );
        return response.data;
    },

    moveManuscriptReviewToAuthor: async (
        payload: MoveManuscriptReviewToAuthorPayload
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/ReviewerEvaluations/MoveManuscriptReviewToAuthor', payload);
        return response.data;
    },

    requestRevisedCopyFromAuthor: async (
        payload: RequestRevisedCopyFromAuthorPayload
    ): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            'https://tetfundtagapi.lloydant.com/api/RevisedCopy/RequestRevisedCopyFromAuthor',
            payload
        );
        return response.data;
    },

    assignReviewerEvaluationPanel: async (
        payload: AssignReviewerEvaluationPanelPayload
    ): Promise<ApiResponse<AssignReviewerEvaluationPanelResult[]>> => {
        const response = await apiClient.post(
            '/ReviewerEvaluations/GroupMemberAssignmentForReviewerEvaluation',
            payload
        );
        return response.data;
    },
};
